import { useUser } from "../context/useUser";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../components/header";
import RotatingPhotos from "../components/rotatingPhotos";
import Footer from "../components/footer";
import cat1 from '../assets/reititys.png'
import cat2 from '../assets/pistorasia.png'
import cat3 from '../assets/termostaatti2.png'
import cat4 from '../assets/kalustejärjestys.png'
import cat5 from '../assets/nostokylpyhuone.png'

const url = process.env.REACT_APP_BACKEND_CONNECTION

export default function Home() {
  const { user, selectedCompany } = useUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState("taloyhtio-ja-rapputyyppi");

  const categories = [
    { name: "taloyhtio-ja-rapputyyppi", title: "1. Valitse taloyhtiö ja rapputyyppi", img: cat1 },
    { name: "waterpipes", title: "2. Valitse vesiputkien reititykset huoneistoihin", img: cat1 },
    { name: "electrical-appliances", title: "3. Valitse sähkökalusteet", img: cat2 },
    { name: "heating", title: "4. Valitse laitteet kylpyhuoneeseen", img: cat3 },
    { name: "furniture-arrangement", title: "5. Valitse kalustejärjestys kolmesta vaihtoehdosta", img: cat4 },
    { name: "furniture", title: "6. Valitse kylpyhuoneen kalusteet, valittavana kolme tyylisuuntaa", img: cat5 },
  ];

  useEffect(() => {
    if (!user?.token) return;
    
    if (!selectedCompany?.summaryId || !selectedCompany?.staircase_type_id) {
      setCurrentStep("taloyhtio-ja-rapputyyppi");
      setLoading(false);
      return;
    }

    async function fetchProgress() {
      try {
        const res = await fetch(`${url}/form/summary/current?housing_company_id=${selectedCompany.housing_company_id}&staircase_type_id=${selectedCompany.staircase_type_id}`, {
          headers: { Authorization: `Bearer ${user.token}` },
        });
        const data = await res.json();

        setCurrentStep(data.current_step || data.last_step || "waterpipes");
      } catch (err) {
        console.error("Failed to load progress:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchProgress();
  }, [selectedCompany?.housing_company_id, selectedCompany?.staircase_type_id, selectedCompany?.summaryId, user]);

  const handleNavigate = (step) => {
    navigate(`/${step}`);
  }

  const currentIndex = categories.findIndex((c) => c.name === currentStep);

  return (
    <>
    <Header />
    <RotatingPhotos />

    <main className="home-container">
        <div className="home-content">

          <div className="home-left">
            <div className= "default-textblock">
            <h1 className="default-title">Huoneistojen kalusteiden valinta</h1>
            <p className="default-text">
              Maecenas pharetra tortor in sem varius, volutpat lacinia sapien imperdiet.
              Phasellus et tincidunt lectus. Ut vulputate magna eu neque dictum malesuada.
              Nulla suscipit gravida risus sit amet pellentesque.
            </p></div>
            
            <div className= "default-textblock">
            <h3 className="default-title-small">CURABITUR PULVINAR LACUS ID SEMPER VULPUTATE</h3>
            <p className="default-text">
              Morbi convallis mi eros, in accumsan libero laoreet auctor. Sed ut viverra orci.
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer eu ligula
              blandit consequat at non magna.
            </p>

            <ol className="default-text">
              <li>Taloyhtiö ja rapputyyppi</li>
              <li>Vesiputkien reititys</li>
              <li>Sähkökalusteet</li>
              <li>Lämmitystapa ja laitteet kylpyhuoneeseen</li>
              <li>Kalustejärjestys</li>
              <li>Kylpyhuoneen kalusteet</li>
            </ol>

            <p className="default-text">
              Phasellus sed ante quis diam pulvinar viverra. In ut consectetur sem.
              Pellentesque faucibus tortor sed fringilla hendrerit. Maecenas commodo imperdiet
              imperdiet.
            </p>
          </div>
          <div className= "default-textblock">
            <h3 className="default-title-small">VESTIBULUM LACUS SAPIEN, POSUERE</h3>
            <p className="default-text">
              Nam tristique diam vitae faucibus dapibus. Nullam vestibulum elit sed finibus pharetra. Donec vitae
              quam facilisis, luctus augue sed, pulvinar sapien. In maximus fermentum sagittis. Ut sit amet
              fermentum risus, sed rhoncus risus.
            </p>
            <p className="default-text">
              Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.
              Maecenas pellentesque ex vel tincidunt euismod. Nunc et fringilla nibh, vel rutrum quam. In at mollis
              urna. Aliquam nec ex ac risus feugiat tempus. Vestibulum rhoncus lectus eget lectus fringilla, a posuere
              nibh pharetra. Pellentesque rutrum augue non nisl auctor sagittis quis vitae justo. Aenean consequat
              nunc odio, commodo varius lectus sollicitudin ac. Suspendisse ac ultrices risus. Sed lobortis lectus nisi.
            </p></div>
          </div>

          <div className="home-right">
            {loading ? (
              <p>Ladataan tietoja...</p>
          ) : (
          categories.map((cat, index) => {
            let buttonText = null;
            let buttonClass = "category-button";

            if (currentIndex === -1) {
              buttonText = null;
            } else if (index < currentIndex) {
              buttonText = "Valmis";
              buttonClass += " done";
            } else if (index === currentIndex) {
            if (currentStep === "taloyhtio-ja-rapputyyppi") {
              buttonText = "Aloita valinta";
            } else {
              buttonText = "Jatka tästä";
            }
              buttonClass += " next";
            } else {
              buttonText = null;
            }

          return (
            <div key={cat.name} className={`category-box ${buttonText === null ? "inactive" : ""}`}>
              <h4>{cat.title}</h4>
            <div className="category-content">
            <div className="category-img">
              <img src={cat.img} alt={cat.title} />
            </div>
            <div className="category-text">
            <p>Maecenas pharetra tortor
              in sem varius, volutpat
              lacinia sapien imperdiet.</p>

            {buttonText && (
              <button
                className={buttonClass}
                onClick={() => handleNavigate(cat.name)}>
                {buttonText}
              </button>
            )}
            </div>
            </div>
            </div>
          );
        })
      )}
          </div>
        </div>
    </main>
    <Footer />
  </>
)}
